// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2m-1";
export var movingGradient = "_2m-4";
export var movingGradientBlock = "_2m-2";
export var skeleton = "_2m-0";
export var skeletonText = "_2m-3";